import { Navigate, Route, Routes } from 'react-router-dom'
import ContentFinderPage from 'pages/ContentFinderPage'
import AuthoringPage from 'pages/AuthoringPage'
import Path from 'routes/Path'
import Topics from './pages/Topics'
import QuizzesPage from 'pages/QuizzesPage'
import { CloseButtonProps, ToastContainer } from 'react-toastify'
import ProtectedRoute from 'routes/ProtectedRoute'
import HomePage from 'pages/HomePage'
import MediaPage from 'pages/MediaPage'
import ErrorPage from 'pages/ErrorPage'
import { BrowserRouter } from 'react-router-dom'
import { ApiProvider } from './providers/ApiProvider'
import { store } from './app/store'
import { Provider } from 'react-redux'
import { AppProvider } from 'providers/AppProvider'
import QuestionsPage from './pages/QuestionsPage'
import QuizDetailsPage from 'pages/QuizDetailsPage'
import QuizCreatePage from 'pages/QuizCreatePage'
import ArchitecturePage from 'pages/ArchitecturePage'
import { ArchitectureApiProvider } from 'providers/ArchitectureApiProvider'
import Grades from './pages/Grades'
import { QuizApiProvider } from 'providers/QuizApiProvider'
import { CompositeAuthProvider } from 'providers/CompositeAuthProvider'

const CustomCloseButton = ({ closeToast }: CloseButtonProps) => {
  return (
    <>
      <button
        className="Toastify__close-button Toastify__close-button--light"
        type="button"
        aria-label="close"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.5286 3.52864C11.7889 3.26834 12.2106 3.26845 12.471 3.52864C12.7113 3.76896 12.73 4.14699 12.5267 4.40852L12.471 4.47102L8.94171 7.99934L12.471 11.5286C12.7314 11.789 12.7314 12.2107 12.471 12.471C12.2307 12.7113 11.8526 12.73 11.5911 12.5267L11.5286 12.471L7.99932 8.94172L4.471 12.471C4.21065 12.7314 3.78897 12.7314 3.52862 12.471C3.28845 12.2307 3.26965 11.8526 3.47296 11.5911L3.52862 11.5286L7.05694 7.99934L3.52862 4.47102C3.26843 4.21066 3.26832 3.78893 3.52862 3.52864C3.76891 3.28835 4.14698 3.26972 4.4085 3.47297L4.471 3.52864L7.99932 7.05696L11.5286 3.52864Z"
            fill="black"
          />
        </svg>
      </button>
    </>
  )
}

function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <AppProvider>
          <ArchitectureApiProvider>
            <QuizApiProvider>
              <ApiProvider>
                <CompositeAuthProvider>
                  <ToastContainer closeButton={CustomCloseButton} />
                  <Routes>
                    <Route
                      path={Path.root.path}
                      element={<ProtectedRoute component={HomePage} />}
                    />
                    <Route path={Path.error.path} element={<ErrorPage />} />
                    <Route
                      path={Path.contentFinder.path}
                      element={<ProtectedRoute component={ContentFinderPage} />}
                    />
                    <Route
                      path={Path.architectures.path}
                      element={<ProtectedRoute component={ArchitecturePage} />}
                    />
                    <Route
                      path={`${Path.architectures.path}/:clientId`}
                      element={<ProtectedRoute component={ArchitecturePage} />}
                    />
                    <Route
                      path={`${Path.architectures.path}/:clientId/:mode`}
                      element={<ProtectedRoute component={ArchitecturePage} />}
                    />
                    <Route
                      path={Path.authoring.path}
                      element={<ProtectedRoute component={AuthoringPage} />}
                    />
                    <Route
                      path={Path.topics.path}
                      element={<ProtectedRoute component={Topics} />}
                    />
                    <Route
                      path={Path.questionGenerator.path}
                      element={<ProtectedRoute component={QuestionsPage} />}
                    />
                    <Route
                      path={Path.quizzes.path}
                      element={<ProtectedRoute component={QuizzesPage} />}
                    />
                    <Route
                      path={`${Path.quizzes.path}/create`}
                      element={<ProtectedRoute component={QuizCreatePage} />}
                    />
                    <Route
                      path={`${Path.quizzes.path}/:quizId`}
                      element={<ProtectedRoute component={QuizDetailsPage} />}
                    />
                    <Route
                      path={Path.mediaPage.path}
                      element={<ProtectedRoute component={MediaPage} />}
                    />
                    <Route
                      path={Path.grades.path}
                      element={<ProtectedRoute component={Grades} />}
                    />
                    <Route
                      path="*"
                      element={<Navigate to={Path.root.path} replace />}
                    />
                  </Routes>
                </CompositeAuthProvider>
              </ApiProvider>
            </QuizApiProvider>
          </ArchitectureApiProvider>
        </AppProvider>
      </Provider>
    </BrowserRouter>
  )
}

export default App
